/**
 * MOCK API
 * - for testing and development
 * - mirrors api.js
 */

import { post } from './requests'
import { parseBody } from '../utils/parseBody'
import {
  snowLoadProtectionMock,
  snowZoneMock,
  tilesMock,
  underRoofMock,
  windSuctionMock,
  windZoneMock,
} from '../common/mocks'
import {tileKinds} from "../common/enums/tile-kinds";

const getTiles = async (values) => values === tileKinds.clay ? tilesMock : []
const getSnowZone = async (values) => snowZoneMock
const getWindZone = async (values) => windZoneMock
const postRoofValidate = async (values) => ({ status: 200 })
const postUnderRoofCalculation = async (values) => underRoofMock
const postSnowLoadProtectionCalculation = async (values) => snowLoadProtectionMock
const postWindSuctionCalculation = async (values) => windSuctionMock
const postPDF = async (values) => {
  const { locale, ...body } = parseBody(values)
  return await post(`/${locale}/pdf`, body, 'blob')
}

export const mockApi = {
  getTiles,
  getSnowZone,
  getWindZone,
  postRoofValidate,
  postUnderRoofCalculation,
  postSnowLoadProtectionCalculation,
  postWindSuctionCalculation,
  postPDF,
}

export default mockApi
